import * as yup from 'yup';

export const schema = yup
  .object({
    busca_produto: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    parametro_etiqueta: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();
